export const DateFormater = (dateString: string) =>
  new Date(dateString).toLocaleString('en-US', {
    day: 'numeric',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  })
